import apiClient from "../../services/api";

export const getServers = ({ filter, token }) => {
  let options = {
    params: filter,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return apiClient.get("/servers/", options);
};
